<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { NAlert } from 'naive-ui'
import { useFailedJobsStore } from '../stores/failed_jobs'

// Standing red banner shown on every route once a Solid Queue job has
// landed in `solid_queue_failed_executions` (#1087). It clears itself on
// the next poll once the failure is gone — either an admin discarded/
// retried it via Mission Control (`/jobs`), or the retry itself
// succeeded — since both leave the count at 0. There's no separate
// "clear" action here on purpose: Mission Control already owns resolving
// a failure, this is just the "go look" signal.
const failedJobs = useFailedJobsStore()
const { summary } = storeToRefs(failedJobs)

const count = computed(() => summary.value?.count ?? 0)
const message = computed(() => {
  const noun = count.value === 1 ? 'job has' : 'jobs have'
  return `${count.value} background ${noun} failed`
})
</script>

<template>
  <NAlert v-if="count > 0" type="error" :bordered="false" class="rounded-none" data-testid="failed-jobs-banner">
    <div class="flex items-center justify-between gap-3">
      <span>{{ message }}</span>
      <a href="/jobs" target="_blank" rel="noopener" class="underline whitespace-nowrap">View in Mission Control</a>
    </div>
  </NAlert>
</template>
